import PersonaService from '../../api/PersonaService';
import ModalErrorAction from './ModalErrorAction';
import ObtenerFechaServidor from '../../api/ObtenerFechaServidor';
import IndicadorCurse from '../../api/IndicadorCurse';
import CreditoService from '../../api/CreditoService';
import DocumentoService from '../../api/DocumentoService';
import Token from '../../api/tokenRefresService'
import MainTipos from './MainTipos';



export const obtenerDatosPersonaAction = (token) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.VALIDADOR_API_PERSONA, payload: { enEjecucionAPIDatosPersona: true } });
      const respuestaDatosPersona = await PersonaService.obtenerDatosPersona(token);
      dispatch({ type: MainTipos.data.OBTENER_DATOS_PERSONA, payload: { datosPersona: respuestaDatosPersona.data } });
    } catch (error) {
      dispatch({ type: MainTipos.data.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const updatePersonaAction = (trackId, datosPersona) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.updatePersona.API_UPDATE_PERONA, payload: { enEjecucionAPI: true } });
      const respuestaDatosPersona = await PersonaService.updateDatosPersona(trackId, datosPersona);
      if (respuestaDatosPersona.data && respuestaDatosPersona.data.actualiza) {
        dispatch({ type: MainTipos.data.updatePersona.UPDATE_PERONA, payload: { updatedatosPersona: respuestaDatosPersona.data.actualiza } });
      } else {
        dispatch({ type: MainTipos.data.updatePersona.ERROR, payload: { error: 'error' } });
        dispatch(ModalErrorAction(true));
      }

    } catch (error) {
      dispatch({ type: MainTipos.data.updatePersona.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const agregarEmailSocioAction = (valor) => {
  return async dispatch => {
    dispatch({ type: MainTipos.data.GUARDAR_EMAIL_SOCIO, payload: { email: valor } });
  };
}

export const agregarTokenSocio = (token) => {
  return async dispatch => {
    dispatch({ type: MainTipos.data.GUARDAR_TOKEN_SOCIO, payload: { token } });
    dispatch({ type: MainTipos.session.GUARDAR_TOKEN_SOCIO_SESSION, payload: { token } });
  };
}

export const agregarIdFlujoSocio = (idFlujo) => {
  return async dispatch => {
    dispatch({ type: MainTipos.data.GUARDAR_IDFLUJO, payload: { idFlujo } });
    dispatch({ type: MainTipos.session.ID_FLUJO_SESSION, payload: { idFlujo } });
  };
}

export const agregarTrackIdSocio = (trackId) => {
  return async dispatch => {
    dispatch({ type: MainTipos.session.ACTUALIZAR_TRACKID_SESSION, payload: { trackId } });
  };
}

export const refresTokenAction = (tokenLiveType) => {
  return async dispatch => {
    if (!tokenLiveType) {
      dispatch({ type: MainTipos.session.REFRES_TOKEN, payload: { tokenLiveStatus:true } });
    } else {
      try {
        // dispatch({ type: MainTipos.data.fecha.INICIO_FECHA_SERVIDOR, payload: { enEjecucionObtenerFechaAPI: true } });
        const refresTokenServicio = await Token.refres();
        if (refresTokenServicio && refresTokenServicio.data && refresTokenServicio.data.refresh ) {
          const newStatusTokenLive = refresTokenServicio.data.refresh;
          dispatch({ type: MainTipos.session.REFRES_TOKEN, payload: { tokenLiveStatus:newStatusTokenLive } });
        } else {
          dispatch({ type: MainTipos.session.REFRES_TOKEN, payload: { tokenLiveStatus:false } });
        }
      } catch (error) {
        dispatch({ type: MainTipos.session.REFRES_TOKEN, payload: { tokenLiveStatus:false } });
        // dispatch(ModalErrorAction(true));
      }
    }

  };
}



export const agregarFechaServidor = (token) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.fecha.INICIO_FECHA_SERVIDOR, payload: { enEjecucionObtenerFechaAPI: true } });
      const respuestaServicio = await ObtenerFechaServidor.obtenerFecha(token);
      dispatch({ type: MainTipos.data.fecha.OBTENER_FECHA_SERVIDOR, payload: { fechaServidor: respuestaServicio.data.fechaHora } });
    } catch (error) {
      dispatch({ type: MainTipos.data.fecha.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
}


export const indicadorCurse = (token, curse) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.indicadorCurse.INICIO_INDICADOR_CURSE, payload: { enEjecucionIndicadorCurseApi: true } });
      const respuesIndicadorCurse = await IndicadorCurse.indicadorCurse(token, curse);
      dispatch({ type: MainTipos.data.indicadorCurse.OBTENER_INDICADOR_CURSE, payload: { curse: respuesIndicadorCurse } });
    } catch (error) {
      dispatch({ type: MainTipos.data.indicadorCurse.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};


export const simularAction = (solicitud, renta, cuotas, listaSeguros, trackId) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.simulacion.INCION_SIMULAR, payload: { enEjecucionAPISimulacion: true } });
      const respuesSimular = await CreditoService.simular(solicitud, renta, cuotas, listaSeguros, trackId);
      if (respuesSimular.data && respuesSimular.data.resultadoSimulacion) {
        // const trackId = respuesSimular ? respuesSimular.trackId : null;
        dispatch({ type: MainTipos.data.simulacion.OBTENER_SIMULACION, payload: { detalle: respuesSimular.data } });
        // dispatch({ type: MainTipos.session.ACTUALIZAR_TRACKID_SESSION, payload: { trackId } });  
      } else if (respuesSimular.error || !respuesSimular.data || !respuesSimular.data.resultadoSimulacion) {
        dispatch({ type: MainTipos.data.simulacion.ERROR_CODE, payload: { error_code: respuesSimular.error.code } });
        // dispatch(ModalErrorAction(true));
      }

    } catch (error) {
      dispatch({ type: MainTipos.data.simulacion.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const solicitarCreditoAction = (enfermedades, trackId) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.solicitar.INCION_SOLICITAR, payload: { enEjecucionSolicitarAPI: true } });
      const respuesSolicitar = await CreditoService.solicitarCredito(enfermedades, trackId);
      // const newTrackId = respuesSolicitar ? respuesSolicitar.trackId : null;
      if (respuesSolicitar.data.solicitaOferta) {
        dispatch({ type: MainTipos.data.solicitar.OBTENER_SOLICITAR, payload: { solicitar: respuesSolicitar.data.solicitaOferta } });
        // dispatch({ type: MainTipos.session.ACTUALIZAR_TRACKID_SESSION, payload: { newTrackId } });
      } else {
        dispatch({ type: MainTipos.data.solicitar.ERROR, payload: { error: true } });
        dispatch(ModalErrorAction(true));
      }

    } catch (error) {
      dispatch({ type: MainTipos.data.solicitar.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};


export const enviarDocumentoAction = (trackId, files, comentario, documentoFinal) => {
  return async dispatch => {
    try {
      // dispatch({ type: MainTipos.data.enviarSolicitud.ARCHIVO_ENVIANDO, payload: { enEjecucionEnviarSolicitud: true } });
      const respuestaEnviarDocumento = await DocumentoService.enviarDocumento(trackId, files, comentario, documentoFinal);
      if (respuestaEnviarDocumento.data && respuestaEnviarDocumento.data.documentosAdjuntos) {
        // dispatch({ type: MainTipos.data.enviarSolicitud.ARCHIVO_ENVIADO, payload: { enviarSolicitud: respuestaEnviarDocumento.data.documentosAdjuntos } });
      } else {
        // dispatch({ type: MainTipos.data.enviarSolicitud.ERROR, payload: { error: 'error' } });
        dispatch(ModalErrorAction(true));
      }
    } catch (error) {
      dispatch({ type: MainTipos.data.enviarSolicitud.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const enviarSolicitudAction = (trackId, comentario) => {
  return async dispatch => {
    try {
      dispatch({ type: MainTipos.data.enviarSolicitud.ARCHIVO_ENVIANDO, payload: { enEjecucionEnviarSolicitud: true } });
      const respuestaEnviarDocumento = await DocumentoService.enviarSolicitud(trackId, comentario);
      if (respuestaEnviarDocumento.data && respuestaEnviarDocumento.data.documentosAdjuntos) {
        dispatch({ type: MainTipos.data.enviarSolicitud.ARCHIVO_ENVIADO, payload: { enviarSolicitud: respuestaEnviarDocumento.data.documentosAdjuntos } });
      } else {
        dispatch({ type: MainTipos.data.enviarSolicitud.ERROR, payload: { error: 'error' } });
        dispatch(ModalErrorAction(true));
      }
    } catch (error) {
      dispatch({ type: MainTipos.data.enviarSolicitud.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const mostrarCreditoAction = () => {
  return async dispatch => {
    try {
      // dispatch({ type:MainTipos.data.enviarSolicitud.ARCHIVO_ENVIANDO, payload: { enEjecucionEnviarSolicitud: true } });
      const respuestamostrarCredito = await CreditoService.mostrarCredito();
      if (respuestamostrarCredito.trackId && respuestamostrarCredito.data.tieneCredito) {
        dispatch({ type: MainTipos.session.ACTUALIZAR_TRACKID_SESSION, payload: { trackId: respuestamostrarCredito.trackId } });
      } else {
        dispatch(ModalErrorAction(true));
      }

    } catch (error) {
      // dispatch({ type: MainTipos.data.enviarSolicitud.ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

export const setWebViewAction = () => {
  return {
    type: MainTipos.data.webViuw.SET_WEBVIUW
  };
};
